import { t } from 'state/intl/translations';
import { routes } from 'utils/routing';

import {
  OrderIssuesContainer,
  OrderIssuesDetails,
  OrderIssuesHeading,
  OrderIssuesText,
  StyledButton,
  StyledButtonContainer,
} from './styled';

export const NeedHelpLarge = ({ children }: { children: React.ReactNode }) => {
  const visitSupportLabel = t('visitSupport');
  const accessibilityLabel = `${t('needHelp')} ${t('issuesDuringExperience')}`;

  return (
    <OrderIssuesContainer>
      <OrderIssuesDetails accessible accessibilityLabel={accessibilityLabel}>
        <OrderIssuesHeading>{t('needHelp')}</OrderIssuesHeading>
        <OrderIssuesText>
          {t('issuesDuringExperience')}&nbsp;
          {visitSupportLabel.toLowerCase()}
        </OrderIssuesText>
      </OrderIssuesDetails>
      <StyledButtonContainer>
        <StyledButton to={routes.support}>{visitSupportLabel}</StyledButton>
      </StyledButtonContainer>
      {children}
    </OrderIssuesContainer>
  );
};
